export default __webpack_public_path__ + "static/media/bastion.cb8da306.webp";